module.exports = [{
      plugin: require('/Users/marcysutton/Presentations/garbage-pail-components/repo/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"gatsbyRemarkPlugins":["gatsby-remark-import-code"],"remarkPlugins":[null,null]},
    },{
      plugin: require('/Users/marcysutton/Presentations/garbage-pail-components/repo/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/marcysutton/Presentations/garbage-pail-components/repo/node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/marcysutton/Presentations/garbage-pail-components/repo/node_modules/gatsby-theme-mdx-deck/gatsby-browser.js'),
      options: {"plugins":[],"mdx":true,"contentPath":"src/slides","basePath":"/"},
    },{
      plugin: require('/Users/marcysutton/Presentations/garbage-pail-components/repo/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"garbage-pail-components","short_name":"hotgarbage","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/dumpster-fire-icon.png"},
    },{
      plugin: require('/Users/marcysutton/Presentations/garbage-pail-components/repo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
